module.exports = __webpack_public_path__ + "static/test-3883dfecad0dcdec01abf49c502e832e.png";